import React, { useEffect, useRef, useCallback } from "react";
import { StyleSheet, Linking, Text, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { useNotification, useNotificationActions } from "src/hooks";
import { stringDateFullDynamicFormat } from "src/utils/date";
import { useRoute, RouteProp } from "@react-navigation/native";

export type NotificationNavigationParam = {
  id: string;
};

type StackNavigationParam = {
  Notification: NotificationNavigationParam;
};

export const Notification: React.FC = () => {
  const route = useRoute<RouteProp<StackNavigationParam, "Notification">>();
  const [notification] = useNotification(route.params.id);
  const { read } = useNotificationActions();

  useEffect(() => {
    if (notification?.id && notification?.isUnread) {
      read(notification?.id);
    }
  }, [notification, read]);

  return (
    <View style={styles.container}>
      <View style={styles.container}>
        {notification?.title ? (
          <Text style={styles.text}>{notification?.title}</Text>
        ) : null}
        {notification?.createdAt ? (
          <Text style={styles.date}>
            {stringDateFullDynamicFormat(notification?.createdAt)}
          </Text>
        ) : null}
        {notification?.details && (
          <ScrollView showsVerticalScrollIndicator={false}>
            <div
              dangerouslySetInnerHTML={{
                __html: `
                <style>                
                  .notification {
                    font-family: 'Roboto', sans-serif;
                    font-size: 14px;
                    white-space: break-spaces;
                  }
                  img {
                    max-width: 100%;
                    max-height: 100%;
                  }
                </style>
                <div class="notification">${notification?.details}</div>`,
              }}
            />
          </ScrollView>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
    padding: 8,
  },
  text: {
    color: colors.chokuBlack,
    fontSize: 15,
    fontWeight: "600",
    marginBottom: 8,
  },
  date: {
    color: colors.chokuGray,
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 8,
  },
});
